import { render, staticRenderFns } from "./ProductionSection.vue?vue&type=template&id=47a3056a&scoped=true"
import script from "./ProductionSection.vue?vue&type=script&lang=js"
export * from "./ProductionSection.vue?vue&type=script&lang=js"
import style0 from "./ProductionSection.vue?vue&type=style&index=0&id=47a3056a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a3056a",
  null
  
)

export default component.exports